// extracted by mini-css-extract-plugin
module.exports = {"renewDialogContent":"styles_renewDialogContent__20c8l","renewDialogButtons":"styles_renewDialogButtons__1g96s"};